import { Link, Route, Routes } from 'react-router-dom'
import { Forbidden, RequireAuth, RequireRole } from './auth/guards'
import { Shell } from './components/Shell'
import { AlertsPage } from './pages/Alerts'
import { AssetDetailPage, AssetsPage } from './pages/Assets'
import { AreaDashboardPage } from './pages/AreaDashboard'
import { ClientsPage } from './pages/Clients'
import { DashboardPage } from './pages/Dashboard'
import { DataQualityPage } from './pages/DataQuality'
import { ExportsPage } from './pages/Exports'
import { PendingDraftsPage } from './features/field/pending'
import { FieldCardPage } from './pages/field/FieldCard'
import { LubricateForm, MeasureForm } from './pages/field/Forms'
import { InspectWizardPage } from './pages/field/InspectWizard'
import { NewInspectionPage } from './pages/NewInspection'
import { FindingsPage } from './pages/Findings'
import { ImportsPage } from './pages/Imports'
import { InspectionDetailPage, InspectionsPage } from './pages/Inspections'
import { LoginPage } from './pages/Login'
import { LubricationPage } from './pages/Lubrication'
import { MeasurementsPage } from './pages/Measurements'
import { PlantsOverviewPage } from './pages/PlantsOverview'
import { TemplatesPage } from './pages/Templates'
import { UsersPage } from './pages/Users'
import { WorkOrderDetailPage, WorkOrdersPage } from './pages/WorkOrders'

function NotFound() {
  return (
    <section className="state-card">
      <h1 className="state-card__title">Página no encontrada</h1>
      <p>La dirección no corresponde a ninguna página.</p>
      <Link className="btn btn--primary" to="/">Volver al panel</Link>
    </section>
  )
}

export function App() {
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      <Route element={<RequireAuth />}>
        <Route element={<Shell />}>
          <Route path="/" element={<PlantsOverviewPage />} />
          <Route path="/plants/:plantId" element={<DashboardPage />} />
          <Route path="/plants/:plantId/areas/:areaId" element={<AreaDashboardPage />} />
          <Route path="/assets" element={<AssetsPage />} />
          <Route path="/assets/:id" element={<AssetDetailPage />} />
          <Route path="/e/:code" element={<FieldCardPage />} />
          <Route element={<RequireRole roles={['admin', 'engineer', 'inspector']} />}>
            <Route path="/e/:code/inspect" element={<InspectWizardPage />} />
            <Route path="/e/:code/measure" element={<MeasureForm />} />
            <Route path="/e/:code/lubricate" element={<LubricateForm />} />
            <Route path="/inspections/new" element={<NewInspectionPage />} />
          </Route>
          <Route path="/drafts" element={<PendingDraftsPage />} />
          <Route path="/inspections" element={<InspectionsPage />} />
          <Route path="/inspections/:id" element={<InspectionDetailPage />} />
          <Route path="/work-orders" element={<WorkOrdersPage />} />
          <Route path="/work-orders/:id" element={<WorkOrderDetailPage />} />
          <Route path="/findings" element={<FindingsPage />} />
          <Route path="/lubrication" element={<LubricationPage />} />
          <Route path="/measurements" element={<MeasurementsPage />} />
          <Route path="/alerts" element={<AlertsPage />} />
          <Route path="/data-quality" element={<DataQualityPage />} />
          <Route path="/exports" element={<ExportsPage />} />
          <Route path="/templates" element={<TemplatesPage />} />
          <Route element={<RequireRole roles={['admin', 'engineer']} />}>
            <Route path="/imports" element={<ImportsPage />} />
            <Route path="/clients" element={<ClientsPage />} />
          </Route>
          <Route element={<RequireRole roles={['admin']} />}>
            <Route path="/users" element={<UsersPage />} />
          </Route>
          <Route path="/forbidden" element={<Forbidden />} />
          <Route path="*" element={<NotFound />} />
        </Route>
      </Route>
    </Routes>
  )
}
